import styled from 'styled-components';

const ButtonFieldLayout = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`;

export { ButtonFieldLayout };
